import React from "react";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { MultiStepEditSection } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import { NewExternalCalendarStep } from "./model";

export const chooseCalendarTypeSection = (
  calendarType: server.dto.ExternalCalendarTypes,
  setCalendarType: (value: server.dto.ExternalCalendarTypes) => void,
): MultiStepEditSection<NewExternalCalendarStep> => ({
  getNextSection: () => getNextSection(calendarType),
  getPrevSection: () => null,
  isLastStep: () => false,
  section: {
    type: "custom",
    key: "chooseCalendarType",
    render: () => {
      return <SectionPanel.Panel
        header={<PanelSegment.Title title={RESX.ExternalCalendar.NewExternalCalendar} />}
      >
        <RadioGroup
          orientation="vertical"
          options={[{
            label: <div>
              Google Calendar<br />
              <span className="s1_gray">{RESX.ExternalCalendar.NewGoogleCalendarDescription}</span>
            </div>,
            value: "googleCalendar",
          }, {
            label: <div>
              External ICalendar<br />
              <span className="s1_gray">{RESX.ExternalCalendar.NewICalendarDescription}</span>
            </div>,
            value: "iCalendar",
          }]}
          value={calendarType}
          onChange={setCalendarType}
        />
      </SectionPanel.Panel>
    }
  }
});

const getNextSection = (
  calendarType: server.dto.ExternalCalendarTypes,
) => {
  if (calendarType === "googleCalendar") {
    return "googleCalendarConnect";
  } else if (calendarType === "iCalendar") {
    return "externalCalendarConnect";
  }

  return null;
}